import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { RenewLicence, RenewLicenceVariables } from "./__generated__/RenewLicence";
import { CORE_LICENCE_FIELDS } from "../fragments/Licence";

const RENEW_LICENCE = gql`
  ${CORE_LICENCE_FIELDS}
  mutation RenewLicence(
    $productName: String!
    $totalPrice: Decimal!
    $numberOfUsers: Int!
    $licenceType: String!
    $licenceId: String!
    $organizationId: String!
  ) {
    renewLicence(
      input: {
        productName: $productName
        totalPrice: $totalPrice
        numberOfUsers: $numberOfUsers
        licenceType: $licenceType
        licenceId: $licenceId
        organizationId: $organizationId
      }
    ) {
      licence {
        ...CoreLicenceFields
      }
    }
  }
`;

export function useRenewLicence() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<RenewLicence, RenewLicenceVariables>(
    RENEW_LICENCE,
    {
      errorPolicy: "all",
    }
  );
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
